import { ReactComponent as UseIcon } from "../../assets/icons/user.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow-drop-down.svg";

const UserHeaderTemplate = ({name}: {name: string}) => {

    return (
      <div className="d-flex gap-2 align-items-center">
        <UseIcon />
        <span className="user-name">{name}</span>
        <ArrowDown />
      </div>
    );
  };

  export default UserHeaderTemplate;